import { MdOutlinePersonOutline } from "react-icons/md";
import { HiOutlineClock } from "react-icons/hi";
import { Exercise } from "../../../../models/Exercise";
import { format } from "date-fns";
import AddToGoogleCalendar from "../../../shared/CalendarIntegration/AddToGoogleCalendar";

const ReservationDetails: React.FC<{
  exercise: Exercise;
  locale: Locale;
  isDesktop: boolean;
}> = ({ exercise, locale, isDesktop }) => {
  if (isDesktop) {
    return (
      <div>
        <b className="purchased-assort_body__details">
        
          <HiOutlineClock /> Termin: {format(exercise.startTime, "dd.MM.yyyy")}r. |{" "}

          {format(exercise.startTime, "HH:mm")}
        </b>
        <AddToGoogleCalendar exercise={exercise} variant="text" color="secondary" noMargins />
        {exercise.humanName && (
          <b className="purchased-assort_body__details">
            <MdOutlinePersonOutline />
            {exercise.deputyHumanName ? (
              <>
                <s>{exercise.humanName}</s> {exercise.deputyHumanName}
              </>
            ) : (
              <>{exercise.humanName}</>
            )}
          </b>
        )}
      </div>
    );
  }

  return (
    <>
      <b className="purchased-assort_body__details__mobile">
        <b>{format(exercise.startTime, " d MMMM (cccc), HH:mm", { locale: locale })}</b>
      </b>

      <b className="purchased-assort_body__details__mobile">
        {exercise.humanName && (
          <b className="purchased-assort_body__details">
            <MdOutlinePersonOutline />
            {exercise.deputyHumanName ? (
              <>
                <s>{exercise.humanName}</s> {exercise.deputyHumanName}
              </>
            ) : (
              <>{exercise.humanName}</>
            )}
          </b>
        )}
      </b>
    </>
  );
};

export default ReservationDetails;
